import AddLineDataFormatter from '../utils/add_line_data_formatter'

export default class AddLineRowTemplate {
  static render(line) {
    const isSelected = this.selectedLinesValue?.includes(line.id) || false
    const planStatus = line.planStatus || line['plan-status']
    const isDisabled = planStatus === 'active'
    const impTypeCell = AddLineDataFormatter.getImpTypeName(line.impType) || line.impType || '-'

    return `
      <tr style="cursor: pointer;"
          data-line-uuid="${line.id}"
          data-action="click->add-line-modal#toggleLine">
        <td class="status-ok" style="text-align:center">
          ${isDisabled ?
            '<span class="glyphicon glyphicon-play"></span>' :
            `<input type="checkbox" ${isSelected ? 'checked' : ''}>`
          }
        </td>
        <td class="sort_app_name" style="word-break: break-all;">
          ${line.newTraffic ? '<span class="label label-success">New</span>' : ''}
          <a href="${AddLineDataFormatter.getStoreUrl(line.appId)}" target="_blank">
            <img src="${line.appIcon || '/imgs/app_icon.png'}" style="width: 25px; height: 25px; margin-right: 4px; float: left; padding-right: 5px; padding-top: 4px;">
          </a>
          <b>${line.appName || 'Unknown App'}</b>
          <p>
            ${AddLineDataFormatter.getCategoryName(line.categoryId) || '-'}${line.tagName ? ' | ' + line.tagName : ''}${line.dealName ? ' | ' + line.dealName : ''}${AddLineDataFormatter.getHistoryStatusText(line)}
          </p>
        </td>
        <td>${AddLineDataFormatter.getExchangeName(line.exchangeId) || '-'}</td>
        <td>${AddLineDataFormatter.getAdTypeName(line.adType) || '-'}</td>
        <td>${impTypeCell}</td>
        <td>${line.dealId || '-'}</td>
        <td>${AddLineDataFormatter.formatNumber(line.trafficNumber || 0)}</td>
      </tr>
    `
  }
}
